// store/theme/actions.js
import { TOGGLE_THEME } from "./actionTypes";

export const toggleTheme = () => ({
  type: TOGGLE_THEME,
});
